import { createAction, props } from '@ngrx/store';
import { AccountCompletion } from '../../interfaces/account-completion';

export const loadAccountCompletion = createAction(
  '[AccountCompletion/API] Load Account Completion'
);

export const loadAccountCompletionSuccess = createAction(
  '[AccountCompletion/API] Load Account Completion Success',
  props<{ accountCompletion: AccountCompletion }>()
);

export const loadAccountCompletionFailure = createAction(
  '[AccountCompletion/API] Load Account Completion Failure',
  props<{ error: unknown }>()
);

export const skipAccountCompletion = createAction(
  '[AccountCompletion/API] Skip Account Completion'
);

export const skipAccountCompletionSuccess = createAction(
  '[AccountCompletion/API] Skip Account Completion Success',
  props<{ accountCompletion: AccountCompletion }>()
);

export const skipAccountCompletionFailure = createAction(
  '[AccountCompletion/API] Skip Account Completion Failure',
  props<{ error: unknown }>()
);

export const clearAccountCompletion = createAction(
  '[AccountCompletion/API] Clear Account Completion'
);
